import BarChart from 'charts/BarChart/tests/frames';
import BgSection from 'components/BgSection/tests/frames';
import DevLogExplorer from 'components/DevLogExplorer/tests/frames';
import GoneTableFrame from 'containers/GoneTableFrame/tests/frames';
import NewWordsFrame from 'containers/NewWordsFrame/tests/frames';
import OldNewWordsFrame from 'containers/OldNewWordsFrame/tests/frames';
import OmonymsFrame from 'containers/OmonymsFrame/tests/frames';
import ResearchApp from 'containers/ResearchApp/tests/frames';
import Tooltip from 'containers/Tooltip/tests/frames';

export default {
  charts: {
    BarChart,
  },
  components: {
    BgSection,
    DevLogExplorer,
  },
  containers: {
    OldNewWordsFrame,
    GoneTableFrame,
    NewWordsFrame,
    OmonymsFrame,
    Tooltip,
    ResearchApp,
  },
};
